<script>
    let dropdownOpen = false;
</script>

<div class="placeholder-button"></div>

<style>
    .placeholder-button {
        /* Keep the same dimensions as the original button */
        height: 38px; /* 10px padding top/bottom + likely line height */
        width: 100%; /* or specify exact width if needed */
        background-color: #35373a; /* grey color */
        border-radius: 5px;
        /* Remove interactive elements */
        pointer-events: none;
        user-select: none;
    }
</style>